import CityPageTemplate from "../city-template/CityPageTemplate";
import { sanfordConfig } from "./data";

export default function SanfordPage() {
  return <CityPageTemplate config={sanfordConfig} />;
}